import LocalStorage from "../LocalStorage";
import {isDefined} from "../../../utils/Utils";
import moment = require("moment");

/**
 * Full calendar filters
 */
export class FullCalendarFilters {
	constructor(public view: string, public date: moment.Moment) {}

	static default(): FullCalendarFilters {
		return new FullCalendarFilters("week", moment());
	}

	/**
	 * Parse local storage data.
	 * @param data data to parse.
	 * @returns {FullCalendarFilters}
	 */
	static getFromLocalStorageData(data: any): FullCalendarFilters {
		if (!isDefined(data)) {
			return FullCalendarFilters.default();
		}
		return new FullCalendarFilters(data.view, data.date);
	}

	updateDate(value: moment.Moment): FullCalendarFilters {
		this.date = value;
		LocalStorage.saveFullCalendarFilters(this);
		return this;
	}

	updateView(value: string): FullCalendarFilters {
		this.view = value;
		LocalStorage.saveFullCalendarFilters(this);
		return this;
	}
}
